import { render, staticRenderFns } from "./detail-diff.vue?vue&type=template&id=399d1488&"
import script from "./detail-diff.vue?vue&type=script&lang=js&"
export * from "./detail-diff.vue?vue&type=script&lang=js&"
import style0 from "./detail-diff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "detail-diff.vue"
export default component.exports